import Axios from 'axios'
const API_HOST = process.env.VUE_APP_API_HOST
const API_VERSION = process.env.VUE_APP_API_VERSION
const AUTH_ACCESS_TOKEN_KEY = process.env.VUE_APP_AUTH_ACCESS_TOKEN_KEY
const PlaylistService = {
  /**
   * @description Get playlist list
   *
   * @returns {object}
   */
  getPlaylists(params) {
    const getPlaylistsURL = `${API_HOST}/${API_VERSION}/listen/playlists`
    return Axios.get(getPlaylistsURL, {
      headers: {
        Accept: 'application/json'
      },
      params
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get playlist by id
   *
   * @returns {object[]}
   */
  getPlaylistById(playlistId) {
    const getPlaylistsURL = `${API_HOST}/${API_VERSION}/listen/playlists/${playlistId}`
    return Axios.request({
      method: 'GET',
      url: getPlaylistsURL,
      headers: {
        Accept: 'application/json'
      },
      onDownloadProgress: function (progressEvent) {
        // console.log('progressEvent', progressEvent)
      }
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get following playlist by peopleId
   *
   * @returns {object[]}
   */
  getPlaylistFollowing(peopleId) {
    const getPlaylistsURL = `${API_HOST}/${API_VERSION}/listen/playlists/following/${peopleId}`
    return Axios.get(getPlaylistsURL, {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Add playlist to following
   * @param {string[]} playlistsAry
   * @returns {object} success information
   */
  addPlaylistFollowing(playlistsAry) {
    const followPlaylistsURL = `${API_HOST}/${API_VERSION}/listen/playlists/following/follow`
    const token = window.localStorage.getItem(AUTH_ACCESS_TOKEN_KEY)
    return Axios.post(
      followPlaylistsURL,
      {
        playlists: playlistsAry
      },
      {
        headers: {
          Authorization: 'Bearer ' + token,
          Accept: 'application/json'
        }
      }
    )
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Remove playlist to following
   * @param {string[]} playlistsAry
   * @returns {object} success information
   */
  deletePlaylistFollowing(playlistsAry) {
    const unfollowPlaylistsURL = `${API_HOST}/${API_VERSION}/listen/playlists/following/unfollow`
    const token = window.localStorage.getItem(AUTH_ACCESS_TOKEN_KEY)
    return Axios.post(
      unfollowPlaylistsURL,
      {
        playlists: playlistsAry
      },
      {
        headers: {
          Authorization: 'Bearer ' + token,
          Accept: 'application/json'
        }
      }
    )
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Create new playlist
   * @param {object} data - full playlist object
   * @returns {object} created playlist object
   */
  createPlaylist(token, data) {
    const createURL = `${API_HOST}/${API_VERSION}/listen/playlists`
    return Axios.request({
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: createURL,
      data: data
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return null
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Update a playlist by id
   * @param {string} playlistId
   * @param {object} data
   * @returns {object} updated playlist object
   */
  updatePlaylist(token, playlistId, data) {
    const updateURL = `${API_HOST}/${API_VERSION}/listen/playlists/${playlistId}`
    return Axios.request({
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'multipart/form-data'
      },
      url: updateURL,
      data: data
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return null
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Delete a playlist by id
   * @param {string} playlistId
   * @returns {object} delete information
   */
  deletePlaylist(token, playlistId) {
    const deleteURL = `${API_HOST}/${API_VERSION}/listen/playlists/${playlistId}`
    return Axios.request({
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: deleteURL
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return null
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Add a track to a playlist
   * @param {string[]} tracksAry
   * @param {string} playlistId
   * @returns {object} success information
   */
  addTracksToPlaylist(tracksAry, playlistId) {
    const addURL = `${API_HOST}/${API_VERSION}/listen/playlists/${playlistId}/tracks`
    const token = window.localStorage.getItem(AUTH_ACCESS_TOKEN_KEY)
    return Axios.request({
      method: 'POST',
      url: addURL,
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json'
      },
      data: {
        tracks: tracksAry
      }
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Remove a track from a playlist by track id
   * @param {string} tracksId
   * @param {string} playlistId
   * @returns {object} success information
   */
  removeTrackFromPlaylist(trackId, playlistId) {
    const removeURL = `${API_HOST}/${API_VERSION}/listen/playlists/${playlistId}/tracks/${trackId}`
    const token = window.localStorage.getItem(AUTH_ACCESS_TOKEN_KEY)
    return Axios.request({
      method: 'DELETE',
      url: removeURL,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Sort tracks in playlist
   * @param {object} data - full playlist object
   * @returns {object} playlist object
   */
  sortTracksInPlaylist(token, playlistId, tracksAry) {
    const createURL = `${API_HOST}/${API_VERSION}/listen/playlists/${playlistId}/tracks`
    return Axios.request({
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: createURL,
      data: tracksAry
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return null
      })
      .catch(err => {
        console.error(err)
        return null
      })
  }
}
export default PlaylistService
